import { call, put } from 'redux-saga/effects'
import { getStaticJobRoles } from '../apiModules/staticJobRoles'
import * as staticJobRoleEntities from '../reducks/staticJobRoles'

export function* fetchStaticJobRoleEntitiesSaga() {
  const response = yield call(getStaticJobRoles)
  yield put(staticJobRoleEntities.addCollection(response.result))
  return response
}
